export const LD_TARGET_ID_LOCAL_STORAGE_KEY = 'targetId';
export const AUSSIE_REFERRAL_KEY = 'aussie_homes_referred';
